export const COLORS = {
  yellow: "#F0C8A0",
  lightYellow: "#F9EFE4",
  lightGreen: "#E5F1EA",
  green: "#A0D2B4",
  lightBlue: "#5CA3F0",
  blue: "#3C78B4",
  darkBlue: "#233264",
  pink: "#FAD2E6",
  orange: "#F07850",
  red: "#CC0058",
  white: "#FFFFFF"
};
